import React from 'react';
import { Route } from 'react-router-dom';
import { prop } from 'ramda';
import Styles from './styles/Styles';
import CreateStyle from './styles/CreateStyle';
import EditStyle from './styles/EditStyle';
import StyleHistory from './styles/StyleHistory';
import CreateColor from './colors/CreateColor';
import EditColor from './colors/EditColor';
import Colors from './colors/Colors';
import DefaultFont from './defaultFont/DefaultFont';

const Routes = ({
  match
}) => {
  const matchUrl = prop('url', match);
  return (
    <>
      <Route path={`${matchUrl}/styles/creer`} component={CreateStyle}/>
      <Route path={`${matchUrl}/styles/:styleId/historique`} component={StyleHistory}/>
      <Route path={`${matchUrl}/styles/:styleId/edition`} component={EditStyle}/>
      <Route exact path={`${matchUrl}/styles`} component={Styles}/>

      <Route path={`${matchUrl}/couleurs/creer`} component={CreateColor}/>
      <Route path={`${matchUrl}/couleurs/:colorId/edition`} component={EditColor}/>
      <Route exact path={`${matchUrl}/couleurs`} component={Colors}/>

      <Route exact path={`${matchUrl}/police`} component={DefaultFont}/>
    </>
  );
};

export default Routes;
